import { projectApi } from '@highlight-cp/project-api';
import type { SURVEY_TYPES } from '@highlight-cp/project-api';

import { useGetCurrentProjectId } from '../use-get-current-project-id';

const useGetSurveyConfigs = ({
  surveyType,
}: {
  surveyType: (typeof SURVEY_TYPES)[keyof typeof SURVEY_TYPES];
}) => {
  const projectId = useGetCurrentProjectId();
  return projectApi.useGetProjectsByProjectIdSurveyConfigsQuery(
    { projectId: projectId ?? 0, surveyType },
    { skip: !projectId },
  );
};

export default useGetSurveyConfigs;
